interface MessageAlertProps {
  message: string
  type: 'error' | 'success'
  children?: React.ReactNode
}

export const MessageAlert = ({
  message,
  type,
  children
}: MessageAlertProps) => {
  if (!message) return null

  const styles = {
    error: {
      background: '#f8d7da',
      borderColor: '#f5c6cb',
      color: '#721c24'
    },
    success: {
      background: '#d4edda',
      borderColor: '#c3e6cb',
      color: '#155724'
    }
  }

  return (
    <div
      className="alert d-flex flex-column align-items-center justify-content-center text-center font-sm"
      role="alert"
      style={styles[type]}
    >
      <div>{message}</div>
      {children}
    </div>
  )
}
